/**
 * A number above `clipAbove` reads as `999+`: the cell saves its width and the reader is spared
 * `99 999 999.9`, while filters and sorts keep the real value (WAP-1854). `format` is the grid's
 * thousands-separator formatter; `decimals` apply to the unclipped text only.
 */
export function clipNumberText(
  value: number,
  options: { decimals?: number; clipAbove?: number },
  format: (text: string | number) => string,
): string {
  if (options.clipAbove != null && value > options.clipAbove) {
    return `${format(options.clipAbove)}+`;
  }
  return format(value.toFixed(options.decimals ?? 0));
}

/** `1234567` -> `1 234 567`; a gap renders as `0` (the numeric empty-value convention, WAP-1643). */
export function formatNumberWithSpaces(
  value: number | string | null | undefined,
): string {
  return (value ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
